export function createFormRequestDetails(state, data, values) {
  const sampleDetails = {
    fullName: state.sampleRequestDetails.fullName,
    department: state.sampleRequestDetails.department,
    email: data.get("email")
      ? data.get("email").toLowerCase()
      : state.sampleRequestDetails.email,
    purpose: values.purposeSelect
      ? values.purposeSelect
      : state.sampleRequestDetails.purpose,
    endUserLocation: values.endUserLocationSelect
      ? values.endUserLocationSelect
      : state.sampleRequestDetails.endUserLocation,
    executiveChefEmail: values.executiveChefEmailSelect
      ? values.executiveChefEmailSelect
      : state.sampleRequestDetails.executiveChefEmail,
    HODDepartment: values.HODDepartmentSelect
      ? values.HODDepartmentSelect
      : state.sampleRequestDetails.HODDepartment,
    organization: state.sampleRequestDetails.organization,
    needByDate: data.get("needByDate")
      ? data.get("needByDate").replace(/ /g, "")
      : state.sampleRequestDetails.needByDate,
    businessUnit: values.businessUnitSelect
      ? values.businessUnitSelect
      : state.sampleRequestDetails.businessUnit,
  };
  return sampleDetails;
}
